import { useState, useCallback } from 'react'
import { SellerServiceSessionItem, SessionHistorySummary } from '../types'
import { getSessionHistory, getSessionStatistics } from '../services'

export const useSessionHistory = (pluginspaceId: number) => {
  const [sessions, setSessions] = useState<SellerServiceSessionItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [summary, setSummary] = useState<SessionHistorySummary | null>(null)

  const loadHistory = useCallback(
    async (startDate?: string, endDate?: string) => {
      try {
        setLoading(true)
        setError(null)
        
        // Se não informar datas, usar últimas 24h
        let start = startDate
        let end = endDate
        
        if (!start || !end) {
          const now = new Date()
          const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000)
          end = now.toISOString().split('T')[0]
          start = yesterday.toISOString().split('T')[0]
        }
        
        const data = await getSessionHistory(pluginspaceId, start, end)
        setSessions(data)
        
        // Calcular resumo
        const stats = await getSessionStatistics(pluginspaceId)
        setSummary(stats)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro ao carregar histórico')
        setSessions([])
      } finally {
        setLoading(false)
      }
    },
    [pluginspaceId]
  )

  return {
    sessions,
    loading,
    error,
    summary,
    loadHistory,
  }
}
